export const generateColorScale = (items: string[]) => {
  const colors: Record<string, string> = {}
  items.forEach((item, index) => {
    const hue = (index * (360 / (items.length + 1))) % 360
    colors[item] = `hsl(${hue}, 70%, 50%)`
  })
  return colors
}
